import MainboardItem from "./MainboardItem";

export default MainboardItem;
